import React from 'react';
import PropTypes from 'prop-types';

const CustomInput = ({
	id,
	label,
	inAsset,
	value,
	type,
	disabled,
	max_length,
	min_length,
	required,
	isTouched,
	errors,
	onChange
}) => (
	<div className="form-group">
		<label>
			{label}
			{required ? <span>*</span> : null}
		</label>
		<input type="text"
			className={'form-control ' + (isTouched[id] && errors[id] ? 'field-error' : '')}
			id={id}
			disabled={disabled}
			value={value}
			autoComplete="off"
			onChange={e => onChange(e, type, inAsset)} />
		{
			isTouched[id] && errors[id] ?
				<div className="form-control-errors-wrapper">
					{ errors[id] && errors[id]['error_message'] && <p>{errors[id]['error_message']}</p> }
					{ errors[id] === 'required' && <p>{label} is required.</p> }
					{ errors[id] === 'max_length' && <p>Max length is {max_length}</p> }
					{ errors[id] === 'min_length' && <p>Min length is {min_length}</p> }
				</div> :
				null
		}
	</div>
);

CustomInput.propTypes = {
	id: PropTypes.string,
	label: PropTypes.string,
	inAsset: PropTypes.bool,
	value: PropTypes.node,
	type: PropTypes.string,
	disabled: PropTypes.bool,
	max_length: PropTypes.number,
	min_length: PropTypes.number,
	required: PropTypes.bool,
	isTouched: PropTypes.object,
	errors: PropTypes.object,
	onChange: PropTypes.func
};

export default CustomInput;